// extracted by mini-css-extract-plugin
export default {"talentaCard":"TalentaCards_talentaCard__82oyQ","talentaCardImage":"TalentaCards_talentaCardImage__vnq-5"};